

const Nopage = () => {

    return(
        <>no page</>
    )
}

export default Nopage